import {Determinant} from "./determinant";

/**
 * ButtonDeterminant handles button-related events.
 * This is a field determinant (determinantType = "FORMFIELD") with discriminator "Button".
 *
 * Supported button events:
 * - click: User clicks button
 * - print, validate, correction, confirm, etc.
 */
export class ButtonDeterminant extends Determinant {

  public buttonEventName: string;
  public determinantType = "FORMFIELD";

  /**
   * The button component key (stored in sourceFormFieldKey in base Determinant)
   */
  public get buttonKey(): string {
    return this.sourceFormFieldKey;
  }

  public set buttonKey(value: string) {
    this.sourceFormFieldKey = value;
  }

}
